import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/join/:id',
      name: 'join',
      component: () => import('@/views/create.vue')
    },
    {
      path: '/ask/:id/:i',
      name: 'ask',
      component: () => import('@/views/ask.vue')
    },
    {
      path: '/changephone/:id',
      name: 'changephone',
      component: () => import('@/views/changephone.vue')
    },
    {
      path: '/create/register',
      name: 'create',
      component: () => import('@/views/create.vue')
    },
    {
      path: '/create/edit',
      name: 'edit',
      component: () => import('@/views/create.vue')
    },
    {
      path: '/create2/add-file',
      name: 'add-file',
      component: () => import('@/views/create2.vue')
    },
    {
      path: '/create2/upload-image',
      name: 'upload-image',
      component: () => import('@/views/create2.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/pages/login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/views/pages/logout.vue')
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      name: 'error-4042',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
